import { useQuery } from "@tanstack/react-query";
import { sortTasksByDue } from "./sortTasksByDue";
import { taskQueryKey } from "./taskQuery";
import { getTasks } from "./tasksApi";

export const useTasks = (showCompleted: boolean = false) => {
  const { data, isLoading } = useQuery({
    queryKey: taskQueryKey(showCompleted),
    queryFn: ({ signal }) => getTasks(showCompleted, signal),
  });

  const sortedTasks = sortTasksByDue(data);

  return {
    tasks: sortedTasks,
    isLoading,
  };
};
